import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/designTokens';
import { Payment } from '../models/PaymentModels';
import { formatDateTimeKST } from '../utils/dateUtils';
import { MobileTable, MobileTableHeader, MobileTableSection } from '../styles/DashboardMobileStyles';

// 모바일 결제 테이블 Props 인터페이스
interface DashboardPaymentTableMobileProps {
  payments: Payment[];
}

// 모바일 테이블 스타일 커스텀 (결제 테이블용)
const StyledMobileTable = styled(MobileTable)`
  td:nth-child(1), th:nth-child(1) { width: 30%; } // 결제유저명/상품명
  td:nth-child(2), th:nth-child(2) { width: 25%; text-align: right; } // 결제금액
  td:nth-child(3), th:nth-child(3) { width: 20%; text-align: center; } // 결제수단
  td:nth-child(4), th:nth-child(4) { width: 25%; text-align: center; } // 승인날짜
`;

// 모바일 결제 테이블 컴포넌트
const DashboardPaymentTableMobile: React.FC<DashboardPaymentTableMobileProps> = ({ payments }) => {
  // 숫자를 "N,NNN원" 형태로 포맷하는 함수
  const formatCurrency = (amount: number): string => {
    if (amount === 0) return '0원';
    return `${amount.toLocaleString()}원`;
  };

  return (
    <MobileTableSection>
      <MobileTableHeader>
        <h3>결제 목록</h3>
      </MobileTableHeader>
      <StyledMobileTable>
        <thead>
          <tr>
            <th>유저/상품</th>
            <th>금액</th>
            <th>수단</th>
            <th>승인일시</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment, index) => (
            <tr key={index}>
              <td>
                <div style={{ fontSize: '12px', fontWeight: '600' }}>
                  {payment.결제유저명}
                </div>
                <div style={{ fontSize: '10px', color: colors.semantic.text.tertiary, marginTop: '2px' }}>
                  {payment.결제상품명}
                </div>
              </td>
              <td>{formatCurrency(payment.결제금액)}</td>
              <td style={{ fontSize: '11px' }}>
                <div>{payment.결제수단}</div>
                {payment.카드사 && (
                  <div style={{ fontSize: '9px', color: colors.semantic.text.tertiary, marginTop: '1px' }}>
                    {payment.카드사}
                  </div>
                )}
              </td>
              <td style={{ fontSize: '11px' }}>{formatDateTimeKST(payment.승인날짜)}</td>
            </tr>
          ))}
          {payments.length === 0 && (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                표시할 결제 데이터가 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </StyledMobileTable>
    </MobileTableSection>
  );
};

export default DashboardPaymentTableMobile; 